import { render } from "./Edit.vue?vue&type=template&id=38f4de22"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Organizations/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38f4de22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38f4de22', __exports__)) {
    console.log('reload')
    api.reload('38f4de22', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=38f4de22", () => {
    console.log('re-render')
    api.rerender('38f4de22', render)
  })

}


export default __exports__